import { render, staticRenderFns } from "./PrizeDrawIndex.vue?vue&type=template&id=35caab24"
import script from "./PrizeDrawIndex.vue?vue&type=script&lang=js"
export * from "./PrizeDrawIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports